export function descendant (child: Node): boolean {
  let node = child.parentNode;

  while (node) {
    if (node === this) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
}
